import { useContext, useEffect, useState } from "react";
import { Operation, TableHeaders } from "../../../../../utils/Enum.types";
import { Title } from "../../../../../stories/Title/Title";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro";
import Edit from "../../../../../images/EditProfile.svg";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import { useLazyQuery, useMutation } from "@apollo/client";
import { getModifiedScrollHeight } from "../../../../../utils/UtilFunctions";
import {
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../utils/constants";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import { GetStockManufacturers } from "./queries/queries";
import {
  AtsStckManufacturerEdge,
  AtsStckManufacturerOrderField,
  DeleteManufacturerByIdResult,
  DeleteManufacturerByIdVars,
  GetStockManufacturersResult,
  GetStockManufacturersVars,
} from "./queries/types";
import Delete from "../../../../../images/Delete.svg";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { DeleteStockManufacturer } from "./queries/mutations";
import { CommonProps } from "../category/Index";
import LoadingModal from "../../../../pages/LoadingModal";

const List = ({ setOperation,handleClear }: CommonProps) => {


  const { customer_id } = useUrlParams();
  const [searchData, setSearchData] = useState("");
  const { state, dispatch } = useContext(AppContext);
  const [GetManufacturers, { data, loading, fetchMore }] = useLazyQuery<
    GetStockManufacturersResult,
    GetStockManufacturersVars
  >(GetStockManufacturers);
  const { user_details } = useLoggedInUserDetails();

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [manufacturer, setManufacturer] = useState<AtsStckManufacturerEdge[]>(
    []
  );
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [message, setMessage] = useState(emptyMessage);

  const [DeleteManufacturer, { loading: deletionLoading }] = useMutation<
    DeleteManufacturerByIdResult,
    DeleteManufacturerByIdVars
  >(DeleteStockManufacturer, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });

  const dynamicHeaders: TableHeaderProps[] = [
    {
      headerName: "Sl",
      field: "id",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
    },
    {
      headerName: `Manufacturer Description`,
      field: "manufacturer",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: 1,
      hideable:false
    },
  ];
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      headerName: TableHeaders.ACTION,
      field: "actions",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_MANUFACTURER_ID,
                  payload: {
                    manufacturerId: Number(params.row.manufacturer_id),
                  },
                });
                setOperation(Operation.UPDATE);
              }}
            />
            <img
              src={Delete}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_MANUFACTURER_ID,
                  payload: {
                    manufacturerId: Number(params.row.manufacturer_id),
                  },
                });
                setDeleteModal(!deleteModal);
                setOperation(Operation.DELETE);
                handleClear()
              }}
            />
          </>
        );
      },
    },
  ];

  const HandleDelete = async () => {
    setDeleteModal(!deleteModal);
        DeleteManufacturer({
          variables: {
           
            manufacturer_id: state.manufacturerId,
            user_details,
          },
          refetchQueries: [
            {
              query: GetStockManufacturers,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckManufacturerOrderField.MANUFACTURER,
                },
               
                name: searchData,
              },
            },
          ],
        }).then(({ data }) => {
          if (data) {
            setMessage({
              flag: true,
              message: "Manufacturer Deleted Sucessfully",
              operation: Operation.DELETE,
            });
            dispatch({
              type: payloadTypes.SET_MANUFACTURER_ID,
              payload: {
                manufacturerId: 0,
              },
            });
          }
        });
  };

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetStockManufacturers.edges;
              const pageInfo = fetchMoreResult.GetStockManufacturers.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck =
                prevResult.GetStockManufacturers.edges.filter(
                  ({ node: { id } }) =>
                    newEdges.findIndex(
                      ({ node: { id: newId } }) => newId === id
                    ) !== -1
                );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetStockManufacturers: {
                  edges: [...manufacturer, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetStockManufacturers.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetStockManufacturers.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = manufacturer.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setManufacturer(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            manufacturer: node.manufacturer,
            manufacturer_id: node.id,
          }))
        );
      } else {
        setManufacturer(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            manufacturer: node.manufacturer,
            manufacturer_id: node.id,
          }))
        );
      }
      setEndCursor(data.GetStockManufacturers.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const fetchData = async () => {
      try {
       
        if (customer_id) {
          GetManufacturers({
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckManufacturerOrderField.MANUFACTURER,
              },
             
              name: searchData,
            },
          });
        }
      } catch (err) {
        setMessage({
          flag: true,
          message: (err as Error).message,
          operation: Operation.NONE,
        });
      }
    };
    fetchData();
  }, [customer_id, GetManufacturers, searchData]);

  return (
    <>
      <div className="master-data__list">
        <Title variant="subtitle1">List of Manufacturer</Title>
        <div className="master-data__list--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            // onCellClick={(params) => {
            //   if (params.field === "months") {
            //     setViewModal(!viewModal);
            //     handleFilterMonthDetails(params.row.month_id);
            //   }
            // }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
      </div>
      <DeleteModal
        id={state.manufacturerId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <LoadingModal flag={loading || deletionLoading} />
    </>
  );
};

export default List;
